import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { filter } from '@beef/utils';
/**
 * Keeps track of SC Nodes wrapped by Outer
 */
export var NodeRegistry = /*#__PURE__*/function () {
  function NodeRegistry() {
    var _this = this;
    _classCallCheck(this, NodeRegistry);
    _defineProperty(this, "nodes", new WeakMap());
    _defineProperty(this, "uniqueIds", {});
    _defineProperty(this, "uniqueIdNodes", {});
    _defineProperty(this, "findNodesByUniqueId", function (uniqueId) {
      return _toConsumableArray(_this.uniqueIdNodes[uniqueId]);
    });
  }
  _createClass(NodeRegistry, [{
    key: "register",
    value: function register(domNode, _ref) {
      var _this$uniqueIds, _this$uniqueIdNodes;
      var nodeId = _ref.nodeId,
        uniqueId = _ref.uniqueId;
      this.nodes.set(domNode, {
        nodeId: nodeId,
        uniqueId: uniqueId
      });
      (_this$uniqueIds = this.uniqueIds)[nodeId] || (_this$uniqueIds[nodeId] = new Set());
      this.uniqueIds[nodeId].add(uniqueId);

      // Даже одному узлу с uniqueId может соответствовать несколько узлов в интерфейсе
      (_this$uniqueIdNodes = this.uniqueIdNodes)[uniqueId] || (_this$uniqueIdNodes[uniqueId] = new Set());
      this.uniqueIdNodes[uniqueId].add(domNode);
    }
  }, {
    key: "unregister",
    value: function unregister(domNode) {
      var _ref2 = this.getDOMNodeData(domNode) || {},
        nodeId = _ref2.nodeId,
        uniqueId = _ref2.uniqueId;
      if (!nodeId || !uniqueId) return;
      this.uniqueIdNodes[uniqueId].delete(domNode);
      this.uniqueIds[nodeId].delete(uniqueId);
      this.nodes.delete(domNode);
    }
  }, {
    key: "getDOMNodeData",
    value: function getDOMNodeData(domNode) {
      return this.nodes.get(domNode);
    }
  }, {
    key: "findClosestDOMParent",
    value: function findClosestDOMParent(childDomNode) {
      while (!(childDomNode instanceof Document)) {
        if (this.nodes.has(childDomNode)) return childDomNode;
        childDomNode = childDomNode.parentNode;
      }
      return null;
    }
  }, {
    key: "getNodeUniqueIds",
    value: function getNodeUniqueIds(nodeId) {
      return _toConsumableArray(this.uniqueIds[nodeId] || []);
    }
  }, {
    key: "getNodeIdByUniqueId",
    value: function getNodeIdByUniqueId(uniqueId) {
      var match = filter(this.uniqueIds, function (uniqueIds) {
        return uniqueIds.has(uniqueId);
      });
      return Object.keys(match)[0];
    }
  }]);
  return NodeRegistry;
}();